<div class="radialProgressBar progress-{{allocationPercentage}}">
  <div class="overlay">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.8396 2.02734H2.59516C2.04533 2.02734 1.60079 2.61844 1.60028 3.22734C1.59961 4.02734 2.04533 4.81845 2.59516 4.81845H12.9774C13.7629 4.81845 14.3996 4.65521 14.3996 5.44068V12.2673C14.3996 13.2099 13.6355 13.974 12.6929 13.974H3.30628C2.36371 13.974 1.59961 13.2099 1.59961 12.2673V3.62734M10.9974 8.84287L10.9863 8.85401"
        stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  </div>
</div>